import { components } from 'type/ReportServiceSchema';

export type DemographicClassificationDto = components['schemas']['DemographicClassificationDTO2'];

export type DemographicClassificationModel = Readonly<{
  demographicId: number;
  demographicTitle: string;
  classificationId: number;
  classificationTitle: string;
  classificationDescription: string;
}>;

export const mapDemographicClassificationDtoToModel = (
  dto: DemographicClassificationDto
): DemographicClassificationModel => dto;
